import { Link } from 'react-router-dom';
import { topicCollections } from '@/mocks/videos';

export default function TopicCollections() {
  return (
    <section className="bg-background-50 py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mb-7 flex items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-bookmark-3-line text-lg" />
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">热门视频专题合集</h2>
            </div>
            <p className="mt-2 text-sm text-foreground-500">按主题聚合的资源专题，一键找到你想看的那一类</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {topicCollections.map((topic) => (
            <Link
              key={topic.id}
              to={`/category/${topic.slug}`}
              className="group relative block h-44 overflow-hidden rounded-lg border border-background-200/70"
            >
              <img
                src={topic.cover}
                alt={topic.title}
                title={`${topic.title} - 麻豆精品入口蜜桃专题合集`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/35 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-background-50">{topic.title}</h3>
                  <span className="rounded-full bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
                    {topic.count} 部
                  </span>
                </div>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-100/85">{topic.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}